import { Trans } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import { getDefaultExchangeDuration } from '@/models/workflow';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const ManualExchangeDueDays = () => {
  const { article } = useArticleContext();
  const { request, workflow } = useRequestContext();

  const defaultWorkflowValue = getDefaultExchangeDuration({ workflow, request });

  return (
    <p>
      <InlineText color="secondary">
        •{' '}
        <Trans id="service-choice.exchange.exchange-duration.label">
          Exchange duration (est.):
        </Trans>{' '}
      </InlineText>
      <InlineText weight="medium">
        {article.manualExchangeDueDays ?? defaultWorkflowValue}{' '}
        <Trans id="service-choice.exchange.exchange-duration.days">days</Trans>
      </InlineText>
    </p>
  );
};
